import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { getIconSize } from '../utilities/index.js';
const HotAirBalloon = forwardRef(({ size = 'medium', fill = 'currentColor', ...props }, ref) => {
    const { iconWidth, iconHeight } = getIconSize(size);
    const ariaLabel = props['aria-label'];
    const ariaLabelledby = props['aria-labelledby'];
    let ariaHidden = true;
    if (ariaLabel || ariaLabelledby) {
        ariaHidden = false;
    }
    return (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", ref: ref, fill: fill, width: iconWidth, height: iconHeight, "aria-hidden": ariaHidden, ...props, children: _jsx("path", { d: "M16.667 6.667c0 1.5-.5 2.875-1.334 4L12.5 14.583v1.25h-1.25v-1.25h-2.5v1.25H7.5v-1.25l-2.833-3.916a6.667 6.667 0 1 1 12-4M7.5 17.333v.792C7.5 19.167 8.167 20 9.208 20h1.584c1.041 0 1.708-.833 1.708-1.875v-.792z" }) }));
});
HotAirBalloon.displayName = 'HotAirBalloon';
HotAirBalloon.__iconComponentType = 'standard';
export default HotAirBalloon;
//# sourceMappingURL=HotAirBalloon.js.map